<div class="flex justify-between items-center mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Atribuir fornecedor — {{ comprasOsIds.length }} OS selecionada(s)
  </div>
</div>

<div [formGroup]="form">
  <div [formGroup]="supplierFilterForm" class="mb-2 flex justify-between items-center gap-3">
    <mat-form-field class="input-tg search-tg no-message-new w-4/12" appearance="outline">
      <mat-label>Filtrar por nome</mat-label>
      <input matInput formControlName="nome" />
    </mat-form-field>
    <mat-form-field class="input-tg search-tg no-message-new w-4/12" appearance="outline">
      <mat-label>Filtrar por CNPJ</mat-label>
      <input matInput formControlName="cnpj" />
    </mat-form-field>
    <mat-form-field class="input-tg search-tg no-message-new w-4/12" appearance="outline">
      <mat-label>Filtrar por cidade</mat-label>
      <input matInput formControlName="cidade" />
    </mat-form-field>
  </div>

  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-6/12"
      appearance="outline"
    >
      <mat-label>Fornecedor</mat-label>
      <mat-select formControlName="fornecedorId">
        @for (supplier of suppliers; track supplier.id) {
          <mat-option [value]="supplier.id">
            {{ supplier.nomeFantasia ?? supplier.nome ?? supplier.razaoSocial }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Valor de compra</mat-label>
      <input matInput currencyInput formControlName="valorCompra" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Valor motorista (freelancer)</mat-label>
      <input matInput currencyInput formControlName="valorMotorista" />
    </mat-form-field>

    <div class="w-4/12">
      <mat-checkbox formControlName="freelancer"
        >Motorista freelancer (cobrado à parte)</mat-checkbox
      >
    </div>
  </div>

  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Venda sem taxa (total)</mat-label>
      <input matInput [value]="totalVendaSemTaxaDisplay" readonly />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Multiplicador venda</mat-label>
      <input
        matInput
        type="number"
        step="0.01"
        formControlName="multiplicadorVenda"
      />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Target (total)</mat-label>
      <input matInput [value]="targetTotalDisplay" readonly />
    </mat-form-field>
  </div>

  @if (multiplicadorTravado) {
    <div class="mb-3 text-xs text-gray-500">
      Multiplicador fixo em 0,55 — {{ osTravadasCount }} de {{ itens.length }} OS selecionada(s) tem divisor
      ausente ou ≥ 0,55. Pra ajustar o multiplicador de uma OS com divisor menor, use a edição individual.
    </div>
  } @else if (!isGestor) {
    <div class="mb-3 text-xs text-gray-500">
      Somente o Gestor de Reserva/Compras pode alterar o multiplicador.
    </div>
  }

  @if (osSemVenda > 0) {
    <div class="mb-3 text-sm text-orange-600">
      {{ osSemVenda }} OS selecionada(s) sem item de proposta vinculado — sem
      valor de venda, fora do cálculo do target.
    </div>
  }

  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-6/12"
      appearance="outline"
    >
      <mat-label>Observação O.S.</mat-label>
      <textarea matInput formControlName="observacaoOs"></textarea>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-6/12"
      appearance="outline"
    >
      <mat-label>Observação ao fornecedor</mat-label>
      <textarea matInput formControlName="obsFornecedorOperador"></textarea>
    </mat-form-field>
  </div>

  <div class="flex justify-end items-center gap-2">
    <button mat-flat-button class="btn-tg-white" (click)="close()" [disabled]="saving">
      Cancelar
    </button>
    <button mat-flat-button class="btn-tg" (click)="save()" [disabled]="saving">
      @if (saving) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Confirmar
      }
    </button>
  </div>
</div>
